import React, { FC } from 'react';

// Shared UI Library Components
import {
  CustomIcon,
  CustomTooltip, EIconName,
  ListEllipsis,
  SwitchElement,
  UserAvatar
} from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './counsellor-option.scss';

// Models
import {
  ICompanyPermissionSettingWorker
} from '../../../../../../interfaces/permission-settings.interfaces';

type TCounsellorOptionProps = {
  counsellor: ICompanyPermissionSettingWorker;
  canAllEditPD: boolean;
  // canAllEditAvailability: boolean;
  canAllSeeRates: boolean;
  onEditPDHandler?: (checked: boolean, counsellor: ICompanyPermissionSettingWorker) => void;
  // onEditAvailabilityHandler?: (checked: boolean, counsellor: ICompanyPermissionSettingWorker) => void;
  onSeeRatesHandler?: (checked: boolean, counsellor: ICompanyPermissionSettingWorker) => void;
};

export const CounsellorOption: FC<TCounsellorOptionProps> = (
  {
    counsellor,
    // canAllEditAvailability,
    canAllEditPD,
    canAllSeeRates,
    onEditPDHandler = () => {},
    // onEditAvailabilityHandler = () => {},
    onSeeRatesHandler = () => {}
  }: TCounsellorOptionProps
) => {

  return (
    <div className="counsellor-option">
      <div className="counsellor-option--info">
        <UserAvatar avatarUrl={ counsellor.photo } sizeClass={ 'small' }/>
        <div className="info-block">
          <div className="info-block--name">
            <CustomTooltip
              title={ `${ counsellor.first_name } ${ counsellor.last_name }` }>{ counsellor.first_name } { counsellor.last_name }
            </CustomTooltip>
          </div>
          <div className="info-block--job">
            { !!counsellor?.speciality &&
              <ListEllipsis items={ counsellor?.speciality.map(s => s.name) } hasCounter={ true }/> }
          </div>
        </div>
        { counsellor.worker_company_status !== 'active' && <div className="counsellor-status">
          Inactive
        </div> }
      </div>
      {/*<div className="counsellor-option--switch">*/}
      {/*  <div className="switch--header">*/}
      {/*    Availability Editing <CustomTooltip title={ '' }>*/}
      {/*    <CustomIcon size={ 'size-md' } name={ EIconName.Info }/>*/}
      {/*  </CustomTooltip>*/}
      {/*  </div>*/}
      {/*  <SwitchElement disabled={ canAllEditAvailability }*/}
      {/*                 { ...(canAllEditAvailability ? {*/}
      {/*                   defaultChecked: true,*/}
      {/*                   checked: true*/}
      {/*                 } : {*/}
      {/*                   defaultChecked: counsellor.can_edit_availability,*/}
      {/*                   checked: counsellor.can_edit_availability*/}
      {/*                 }) }*/}
      {/*                 onChange={ (checked) => onEditAvailabilityHandler(checked, counsellor) }/>*/}

      {/*</div>*/}
      <div className="counsellor-option--switch">
        <div className="switch--header">
          Personal Data Editing <CustomTooltip title={ '' }>
          <CustomIcon size={ 'size-md' } name={ EIconName.Info }/>
        </CustomTooltip>
        </div>
        <SwitchElement disabled={ canAllEditPD }
                       { ...(canAllEditPD ? {
                         defaultChecked: true,
                         checked: true
                       } : {
                         defaultChecked: counsellor.can_edit_profile,
                         checked: counsellor.can_edit_profile
                       }) }
                       onChange={ (checked) => onEditPDHandler(checked, counsellor) }/>
      </div>
      <div className="counsellor-option--switch">
        <div className="switch--header">
          Rates Viewing<CustomTooltip title={ '' }>
          <CustomIcon size={ 'size-md' } name={ EIconName.Info }/>
        </CustomTooltip>
        </div>
        <SwitchElement disabled={ canAllSeeRates }
                       { ...(canAllSeeRates ? {
                         defaultChecked: true,
                         checked: true
                       } : { defaultChecked: counsellor.can_see_rates, checked: counsellor.can_see_rates }) }
                       onChange={ (checked) => onSeeRatesHandler(checked, counsellor) }/>
      </div>
    </div>
  );
}
